import { symbolIndexWorkerClient } from '../worker/client.js';

/**
 * Rebuild the symbol index for a workspace parent path in the background worker thread.
 */
export async function buildSymbolIndexAsync(parentPath: string): Promise<{ fileCount: number; tagCount: number }> {
  return symbolIndexWorkerClient.buildFull(parentPath);
}

export { buildSymbolIndexImpl } from './build-symbol-index-impl.js';
